import { getUrlParameter } from './utils';

const jQuery = window.jQuery;

// http://localhost/ctk24/ordersum.php?data={%22email%22:%22obor@example.com%22}

function setOrdersumField(name, value) {
  jQuery('#sum' + name).html(value);
}

export function fillOrderSum(json) {
  setOrdersumField('email', json.email);
  setOrdersumField('company', json.company);
  setOrdersumField('name', json.name);
}

export function orderSumParam2Json() {
  const data = getUrlParameter('data');
  console.log('url data' + data);
  const jsonData = JSON.parse(data);
  console.log('json data' + data);
  const ret = {};
  ret.email = jsonData.email;
  //return ret;
  return jsonData;
}

function submitCard(event) {
  console.log('submitting data');
  const data = getUrlParameter('data');
  window.location.replace(
    'https://mrsio2.ctk.cz/platba?src=CTK24&redirect=http://localhost/ctk24/final.php&data={%22email%22:%22pokus@pokus.aero%22,%22lengthmessage%22:%22jenjeden%20mesic%22,%22pricecode%22:555,%22transactionId%22:%2212345%22}',
  );
  event.preventDefault();
  return false;
}

export function orderSumBindHandlers() {
  console.log('orderSumBindHandlers');
  jQuery('#xformsubmit2').on('click', submitCard);
  jQuery('#formsubmit2').on('click', submitCard);
}
